export default "__VITE_ASSET__389b02a2__"